import { useState, useEffect } from 'react';
import { sizes } from 'v2/resources/types/devices';

export const useWindowSizes = () => {
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    const handleWindowResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };

    window.addEventListener('resize', handleWindowResize);

    return () => {
      window.removeEventListener('resize', handleWindowResize);
    };
  }, []);

  const isDesktop = windowSize.width >= sizes.desktop.min;

  const isTablet =
    windowSize.width >= sizes.tablet.min &&
    windowSize.width < sizes.desktop.min;

  const isMobile =
    windowSize.width >= sizes.mobile.min && windowSize.width < sizes.tablet.min;

  const resolutionNotSupported = windowSize.width < sizes.mobile.min;

  return {
    windowSize,
    isDesktop,
    isTablet,
    isMobile,
    resolutionNotSupported,
  };
};
